module.exports = __webpack_public_path__ + "completed.5182576e.svg";